import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'

import './ParticipantCounter.css'

const ParticipantCounter = ({ count }) => (
  <div styleName="container">
    <div styleName="l-count">
      <p styleName="count">{`${count}`}</p>
    </div>
    <div styleName="l-text">
      <TextLabel color={ColorType.ACCENT} size={SizeType.LARGE} weight={WeightType.HEAVY}>
        人参加中
      </TextLabel>
    </div>
  </div>
)

ParticipantCounter.propTypes = {
  count: PropTypes.number.isRequired
}

ParticipantCounter.defaultProps = {
  count: 0
}

export default compose(pure)(ParticipantCounter)
